/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewer_Ref_N4Inputs */

const en_viewer_ref_n4 = /** @type {(inputs: Viewer_Ref_N4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An empty string is a string, not a null and not an absent key.`)
};

const ko_viewer_ref_n4 = /** @type {(inputs: Viewer_Ref_N4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`빈 문자열은 문자열이며, null도 아니고 없는 키도 아닙니다.`)
};

const ja_viewer_ref_n4 = /** @type {(inputs: Viewer_Ref_N4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`空文字列は文字列で、null でも存在しないキーでもありません。`)
};

/**
* | output |
* | --- |
* | "An empty string is a string, not a null and not an absent key." |
*
* @param {Viewer_Ref_N4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const viewer_ref_n4 = /** @type {((inputs?: Viewer_Ref_N4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewer_Ref_N4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewer_ref_n4(inputs)
	if (locale === "ko") return ko_viewer_ref_n4(inputs)
	return ja_viewer_ref_n4(inputs)
});